import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { checkoutStepDefinition } from "../CheckoutPage/CheckoutStartup";
import { selectOfferStepDefinition } from "../TrainOfferPage/SelectOfferFlow/SelectOfferStartupFlow";
import { ticketOptionMainStepDefinition } from "../TrainOfferPage/TicketOptionFlow/TicketOptionStartupFlow";
import { BookReturnJourneyInitStepDeclaration } from "./Steps/BookReturnJourneyInitStep";
import { BookReturnJourneyTransition } from "./Transition/BookReturnJourneyTransition";

export const bookReturnJourneyStartupMainFlow = new FlowDefinition("BookReturnJourneyFlow");

bookReturnJourneyStartupMainFlow.addStep(BookReturnJourneyInitStepDeclaration);
bookReturnJourneyStartupMainFlow.addStep(selectOfferStepDefinition);
bookReturnJourneyStartupMainFlow.addStep(ticketOptionMainStepDefinition);
bookReturnJourneyStartupMainFlow.addStep(checkoutStepDefinition);

bookReturnJourneyStartupMainFlow.addLink("BookReturnJourneyInit_Step", "SelectOfferFlow");
bookReturnJourneyStartupMainFlow.addLink("BookReturnJourneyInit_Step", "TicketOptionFlow");
bookReturnJourneyStartupMainFlow.addLink("TicketOptionFlow", "CheckoutFlow");

bookReturnJourneyStartupMainFlow.addTransition(BookReturnJourneyTransition, "BookReturnJourneyInit_Step");

bookReturnJourneyStartupMainFlow.setStartStep("BookReturnJourneyInit_Step");

export const bookReturnJourneyStartupStepDefinition = new StepDefinition({
    stepName: "BookReturnJourneyFlow",
    stepFlow: bookReturnJourneyStartupMainFlow,
    contextIsolation: false
})